<template>
  <div class="m_aboutgoods project_detail">
    <mt-header title="My Appointments">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="m_content">
      <ul
        class="ul_list"
        v-show="zsList.list.length>0"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="false"
        infinite-scroll-distance="1"
        :infinite-scroll-immediate-check="false"
        >
        <li class="li_itemL" v-for="(item,index) in zsList.list" :key="index" @click="$router.push('/exhibitor/details/'+item.offid+'/'+item.ocid)">
          <div class="cen_left">
            <h3 class="exh_title">
              <img class="exh_logo" :src="item.corplogo_cn" />
              {{item.corpname_en}}
            </h3>
            <p>
              <span>Booth No：{{item.booth}}</span>
              <span class="span2">Booth Area：{{item.area}}m²</span>
            </p>
            <p> Meeting Time：{{item.ctime}} </p>
            <p> Leave a Message：{{item.connet}} </p>
          </div>
          <div class="btn_group">
            <el-button v-if="item.status*1==0" @click.stop="isCollect(item.id)">Delete</el-button>
            <el-button disabled :class="item.status*1==0?'blue':'black'">{{item.status*1==0?'Confirm':'Confirmed '}}</el-button>
          </div>
        </li>
        <li class="more_loading" >
          <span v-show="zsList.list.length<zsList.listnum">
            <div class="m_upload">
              <mt-spinner type="snake" color="#00ccff" :size="20" ></mt-spinner>
              <span>Loading...</span>
            </div>
          </span>
          <span v-show="zsList.list.length>=zsList.listnum" class="over">Final Page</span>
        </li>
      </ul>
      <div v-show="zsList.list.length<=0" class="zanwu">
        <div><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" alt=""/></div>
        <p class="p">No data is available!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import { reqMyCorpApp, reqCorpAppOff } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      zsList:{list:[],listnum:99,pagelistnum:0,thispage:0},
    }
  },
  methods:{
    loadMore(){
      if (this.zsList.thispage*this.zsList.pagelistnum*1>=this.zsList.listnum*1) {
        return
      }
      this.init(this.zsList.thispage*1+1)
      // console.log(123);
    },
    async init(page=1){
      const response = await reqMyCorpApp(page)
      // console.log(response);
      if(response.code==2){
          this.zsList.list.push(...response.reslist)
          this.zsList.thispage=response.thispage
          this.zsList.listnum=response.listnum
          this.zsList.pagelistnum=response.pagelistnum
      }else{
          this.zsList={
            list:[],
            listnum:0,
            pagelistnum:0,
            thispage:0
          }
        }
      // console.log(response);
    },
    async isCollect(id){//修改预约状态
      const response = await reqCorpAppOff(id)
      if (response.code==3) {
        let index = this.zsList.list.findIndex(item=>item.id==id)
        if (index>=0) {
          let {zsList} =this
          zsList.list.splice(index,1)
          this.zsList = zsList
        }
      }
    },
  }
}
</script>

<style scoped>
  .m_aboutgoods{
    height: 100%;
    overflow: hidden;
  }
  .m_content{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
  }
  .li_itemL{
    width: 100%;
    background-color: white;
    margin-top: 6px;
    box-shadow: 0 0 6px #b1b1b1;
    display: flex;
    padding: 6px;
    border-radius: 4px;
  }
  .cen_left{
    width: calc(100% - 70px);
  }
  .exh_title{
    height: 44px;
    font-size: 16px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .exh_logo{
    width: 64px;
    padding: 0 10px;
  }
  .cen_left p{
    padding: 4px;
    line-height: 18px;
  }
  .cen_left p .span2{
    margin-left: 10px;    
  }

  .btn_group{
    width: 70px;
    padding-top: 16px;
    text-align: center;
  }
  .btn_group button{
    padding: 8px;
    /* width: 60px; */
    margin-left: 0;
    margin-top: 10px;
    font-size: 12px;
    width: 100%;
  }
  .btn_group>>>.el-button:focus,.btn_group>>> .el-button:hover{
    color: #606266;
    border: 1px solid #dcdfe6;
    background-color:white
  }
  .blue{
    color: #008baf;
  }
  .black{
    color: #333;
  }
  /* 加载中 */
  .more_loading{
    padding: 10px 0;
    line-height: 24px;
  }
  /* 空 */
  .zanwu{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -70%);
    width: 240px;
    text-align: center;
  }
</style>